import React, { useEffect, useState } from "react";
import { TbDownload } from "react-icons/tb";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExpeditionService from "../services/expedition/ExpeditionService";

export const ListingPDFButton = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [dataListe, setDataListe] = useState([]);

    const getPendingEmballages = async () => {
        try {
            const res = await ExpeditionService.getAllExpedition("en-attente-d-emballage", {
                all_shippings: 0,
                category: "all",
                page: 1,
                per_page: 25,
                type: "medical",
                type_expedition: "all",
            });

            const data = res.data.data.data.map((item) => {
                const emballage = item.shipping_emballage?.[0];
                return {
                    ref: item.ref,
                    date: item.delivery_date?.split(" ")[0] || "",
                    typeCaisses: emballage?.emballage?.nom_produit || "",
                    typeDiagnobag: emballage?.type_diagnobag?.libelle || "",
                    typeSonde: emballage?.type_sonde?.libelle || "",
                    expediteur: item?.expeditor?.fullname || "",
                    destinataire: item?.receiver?.fullname || "",
                };
            });

            setDataListe(data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getPendingEmballages();
    }, []);

    const generatePDF = () => {
        const doc = new jsPDF("landscape");

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Titre principal
        doc.setFontSize(16);
        doc.text("Listing de préparation des caisses", pageWidth / 2, 20, { align: "center" });

        const headers = [
            [
                "Réf. AWB",
                "Date d'expédition",
                "Type de caisses",
                "Type de diagnobag",
                "Type de sonde",
                "Expéditeur",
                "Destinataire",
            ],
        ];

        const rows = dataListe.map((row) => [
            row.ref,
            row.date,
            row.typeCaisses,
            row.typeDiagnobag,
            row.typeSonde,
            row.expediteur,
            row.destinataire,
        ]);

        // autoTable avec pagination + callback pour pied de page
        autoTable(doc, {
            startY: 30,
            head: headers,
            body: rows,
            styles: { fontSize: 10 },
            didDrawPage: (data) => {
                // Pied de page avec numéro de page
                const pageCount = doc.getNumberOfPages();
                const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
                doc.setFontSize(9);
                doc.text(`Page ${currentPage} / ${pageCount}`, pageWidth - 20, pageHeight - 10);
            },
        });

        // Ligne Total tout en bas du dernier tableau
        const finalY = doc.lastAutoTable.finalY;
        doc.setFontSize(12);
        doc.text(`Nb total de caisses : ${dataListe.length}`, 14, finalY + 10);

        doc.save("listing-caisses.pdf");
    };
    return (
        <button
            onClick={generatePDF}
            disabled={isLoading}
            className="bg-medical text-lf font-semibold text-white rounded-md p-2 flex gap-2 items-center disabled:opacity-50"
        >
            <TbDownload className="w-5 h-5 text-white" />
            <span>{isLoading ? "Chargement des données..." : "Exporter en PDF"}</span>
        </button>
    );
};
